"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousSearchSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class AnonymousSearchSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'ANONYMOUS_SEARCH';
    }
}
exports.AnonymousSearchSuccessEvent = AnonymousSearchSuccessEvent;
//# sourceMappingURL=anonymous.events.js.map